import React, { useState } from 'react';
import { useApi, Spinner, ErrBanner, fmtDate, fmtNum } from '../../hooks/useApi';
import { api } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import './SaleBillLubeGST.css';

function amtToWords(n) {
  const ones=['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
  const tens=['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
  const num=Math.floor(n);
  if(num<20) return ones[num];
  if(num<100) return tens[Math.floor(num/10)]+(num%10?' '+ones[num%10]:'');
  if(num<1000) return ones[Math.floor(num/100)]+' Hundred'+(num%100?' '+amtToWords(num%100):'');
  if(num<100000) return amtToWords(Math.floor(num/1000))+' Thousand'+(num%1000?' '+amtToWords(num%1000):'');
  return amtToWords(Math.floor(num/100000))+' Lakh'+(num%100000?' '+amtToWords(num%100000):'');
}

export default function SaleBillLubeGST() {
  const { data: bills, loading, error } = useApi(() => api.lubeSales.list(), []);
  const { user } = useAuth();
  const [selectedId, setSelectedId] = useState(null);
  const [msg, setMsg] = useState('');
  const notify = (m) => { setMsg(m); setTimeout(() => setMsg(''), 3500); };
  const bill = (bills||[]).find(b=>b.id===selectedId);
  const cgst = bill ? fmtNum(Number(bill.tax)/2) : 0;
  const sgst = bill ? fmtNum(Number(bill.tax)/2) : 0;

  const handleExport = () => {
    const rows = bills || [];
    if (!rows.length) { notify('❌ No bills to export'); return; }
    const printWindow = window.open('', '_blank');
    if (!printWindow) { notify('❌ Pop-up blocked. Please allow pop-ups to export.'); return; }
    const todayStr = new Date().toLocaleDateString();
    const totalQty = rows.reduce((s, r) => s + Number(r.qty || 0), 0);
    const totalAmount = rows.reduce((s, r) => s + Number(r.amount || 0), 0);

    const tableHtml = `
      <html>
        <head>
          <title>Lube GST Bills - ${todayStr}</title>
          <style>
            body { font-family: 'Nunito', sans-serif; padding: 20px; color: #333; }
            h2 { color: #1a6fad; margin-bottom: 5px; }
            .meta { font-size: 12px; color: #666; margin-bottom: 20px; border-bottom: 2px solid #eee; padding-bottom: 10px; }
            table { width: 100%; border-collapse: collapse; margin-top: 10px; }
            th { background: #f8fafc; color: #64748b; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; padding: 10px; border: 1px solid #e2e8f0; text-align: left; }
            td { padding: 10px; border: 1px solid #e2e8f0; font-size: 12px; }
            .text-right { text-align: right; }
            .total-row { background: #f1f5f9; font-weight: bold; }
          </style>
        </head>
        <body>
          <h2>Lube GST Bills</h2>
          <div class="meta">Generated on: ${todayStr} | Total Bills: ${rows.length} | Total Amount: ₹${fmtNum(totalAmount)}</div>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Bill No</th>
                <th>Customer</th>
                <th>Product</th>
                <th class="text-right">Qty</th>
                <th class="text-right">Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              ${rows.map((b, i) => `
                <tr>
                  <td>${i + 1}</td>
                  <td>${fmtDate(b.sale_date)}</td>
                  <td style="font-weight: bold; color: #1a6fad;">${b.bill_no || ''}</td>
                  <td>${b.customer_name || ''}</td>
                  <td>${b.product_name || ''}</td>
                  <td class="text-right">${b.qty}</td>
                  <td class="text-right">₹${fmtNum(b.amount)}</td>
                </tr>
              `).join('')}
              <tr class="total-row">
                <td colspan="5" class="text-right">TOTAL</td>
                <td class="text-right">${fmtNum(totalQty)}</td>
                <td class="text-right">₹${fmtNum(totalAmount)}</td>
              </tr>
            </tbody>
          </table>
          <script>window.print();</script>
        </body>
      </html>
    `;

    printWindow.document.write(tableHtml);
    printWindow.document.close();
  };

  // ── Registered-client details (fall back to a safe placeholder
  //    only if the user object is missing station_* for some reason)
  const company = {
    name:    user?.station_name    || user?.name || 'Company Name',
    address: user?.station_address || '',
    gstin:   user?.station_gstin   || '',
    state:   user?.station_state   || '',
    phone:   user?.phone           || '',
  };

  return (
    <div className="sale-bill-page">
      <div className="page-header">
        <h2 className="page-title">Sale Bill (Lube-GST)</h2>
        <div style={{display:'flex',gap:8}}>
          {selectedId && <button className="btn btn-success btn-sm" onClick={()=>window.print()}>🖨️ Print</button>}
          <button className="export-btn" onClick={handleExport}>⬆ Export</button>
        </div>
      </div>

      {msg && <div style={{ padding: '6px 12px', background: '#f0fff4', border: '1px solid #9ae6b4', borderRadius: 6, marginBottom: 8, fontSize: 13 }}>{msg}</div>}

      {loading && <Spinner />}
      {error   && <ErrBanner msg={error} />}

      {!loading && (
        <div className="invoice-list section-card">
          <div className="section-header">Select Bill to View / Print</div>
          <div className="table-wrapper">
            <table className="data-table">
              <thead><tr>
                <th style={{textAlign:'left'}}>#</th><th style={{textAlign:'left'}}>Date</th>
                <th style={{textAlign:'left'}}>Bill No</th><th style={{textAlign:'left'}}>Customer</th>
                <th style={{textAlign:'left'}}>Product</th><th>Qty</th>
                <th>Amount (₹)</th><th style={{textAlign:'left'}}>Action</th>
              </tr></thead>
              <tbody>
                {(bills||[]).map((b,i)=>(
                  <tr key={b.id} className={selectedId===b.id?'selected-row':''}>
                    <td>{i+1}</td><td>{fmtDate(b.sale_date)}</td>
                    <td style={{fontWeight:700,color:'var(--primary)',fontFamily:'monospace'}}>{b.bill_no}</td>
                    <td>{b.customer_name}</td><td>{b.product_name}</td>
                    <td className="right-align">{b.qty}</td>
                    <td className="right-align">₹{fmtNum(b.amount)}</td>
                    <td><button className="btn btn-sm btn-info" onClick={()=>setSelectedId(b.id)}>👁 View</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {bill && (
        <div className="gst-invoice">
          <div className="invoice-header">
            <div className="invoice-company">
              {/* ── Registered client details (from login/profile) ── */}
              <h2>{company.name}</h2>
              {company.address && <p>{company.address}</p>}
              <p>
                {company.gstin && <>GSTIN: {company.gstin}</>}
                {company.gstin && company.state && ' | '}
                {company.state && <>State: {company.state}</>}
                {(company.gstin || company.state) && company.phone && ' | '}
                {company.phone && <>Phone: {company.phone}</>}
              </p>
            </div>
            <div className="invoice-title">
              <div>TAX INVOICE</div>
              <div className="invoice-no">{bill.bill_no}</div>
              <div className="invoice-date">{fmtDate(bill.sale_date)}</div>
            </div>
          </div>
          <div className="invoice-body">
            <div className="invoice-party"><strong>Bill To:</strong> {bill.customer_name||'Cash Customer'}</div>
            <table className="invoice-table">
              <thead><tr>
                <th>#</th><th>Description</th><th>HSN</th><th>Qty</th>
                <th>Rate</th><th>Taxable Amt</th><th>CGST</th><th>SGST</th><th>Total</th>
              </tr></thead>
              <tbody>
                <tr>
                  <td>1</td><td>{bill.product_name}</td><td>27101991</td>
                  <td>{bill.qty} Ltr</td>
                  <td>₹{fmtNum(bill.rate)}</td>
                  <td>₹{fmtNum(Number(bill.qty)*Number(bill.rate))}</td>
                  <td>₹{cgst} ({Number(bill.tax_per)/2}%)</td>
                  <td>₹{sgst} ({Number(bill.tax_per)/2}%)</td>
                  <td>₹{fmtNum(bill.amount)}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5} style={{textAlign:'right',fontWeight:700}}>Total</td>
                  <td>₹{fmtNum(Number(bill.qty)*Number(bill.rate))}</td>
                  <td>₹{cgst}</td><td>₹{sgst}</td>
                  <td>₹{fmtNum(bill.amount)}</td>
                </tr>
              </tfoot>
            </table>
            <div className="invoice-footer">
              <div>Amount in Words: <strong>Rupees {amtToWords(Number(bill.amount))} Only</strong></div>
              <div className="invoice-sign">Authorised Signatory</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
